import router from "@/router"

const state = () => ({
    user: null,
    isAuthenticated: false,
    isLoading: false,
    error: null
})

const mutations = {
    SET_USER(state, user) {
        state.user = user
        state.isAuthenticated = !!user
    },
    SET_LOADING(state, value) {
        state.isLoading = value
    },
    SET_ERROR(state, error) {
        state.error = error
    },
    CLEAR_AUTH(state) {
        state.user = null
        state.isAuthenticated = false
    }
}

const actions = {
    /**
     * Call ONCE during app bootstrap
     */
    initOAuthListener({ dispatch, commit }) {
        window.addEventListener("message", async (event) => {
            if (event.origin !== window.location.origin) return

            if (event.data?.type === "OAUTH_SUCCESS") {
                commit("SET_LOADING", true)
                commit("SET_ERROR", null)

                try {
                    await dispatch("validate")
                    router.push("/dashboard")
                } catch (e) {
                    commit("SET_ERROR", "Authentication failed")
                } finally {
                    commit("SET_LOADING", false)
                }
            }
        })
    },

    /**
     * Validate session using HttpOnly cookie
     */
    async validate({ commit }) {
        const res = await fetch("/auth/validate", {
            credentials: "include"
        })

        if (!res.ok) {
            commit("CLEAR_AUTH")
            throw new Error("Not authenticated")
        }

        const data = await res.json()
        commit("SET_USER", data)
    },

    /**
     * Logout
     */
    async logout({ commit }) {
        await fetch("/auth/logout", {
            method: "POST",
            credentials: "include"
        })

        commit("CLEAR_AUTH")
        router.push("/login")
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
